import '../types/index.d.ts';

export const createCalendar = (data: Data[], date: Date) => {
  const nowYear = date.getFullYear();
  const nowMonth = date.getMonth();
  const firstDayOfMonth = new Date(nowYear, nowMonth, 1).getDay();
  const lastDateOfMonth = new Date(nowYear, nowMonth + 1, 0).getDate();
  let dateArray = [...Array(42)].map((_, i) => i + 1);
  dateArray = dateArray.map((date) => date - firstDayOfMonth);

  const monthArray: string[] = [];

  // 6週間ループ
  for (let i = 0; i < 6; i++) {
    const weekArray: string[] = ['<tr>']; // 閉じタグはなくても問題なさそう

    // 日付配列から1行分（1週間分）切り取る
    const dateSubArray = dateArray.slice(i * 7, i * 7 + 7);

    for (let i = 0; i < dateSubArray.length; i++) {
      const date = dateSubArray[i] < 1 || dateSubArray[i] > lastDateOfMonth ? '' : dateSubArray[i];
      let color = '0';
      let number = '0';

      for (const prop in data) {
        const date2 = new Date(data[prop]['date']);

        if (nowMonth === date2.getMonth()) {
          if (date === date2.getDate()) {
            color = data[prop]['color'];
            number = String(data[prop].calendar);
          }
        }
      }

      weekArray.push(
        `<td class="color-${color} no-${number}"><p>${date}<p class="noBox"><span class='no'>No.</span>${number}</p></td>`,
      );
    }

    monthArray.push(weekArray.join(''));
  }

  return { __html: monthArray.join('') };
};
